import React from 'react';
import { Link } from 'gatsby';

interface TaggedLinkProps {
  label: string;
  htmlLabel?: React.ReactNode;
  href: string;
  isEcommerceNavigation: boolean;
  isOpen: boolean;
  linkStyles: any;
  setIsModalOpen?: (value: boolean) => void;
  handleEcommerceClick: (
    product: string,
    href: string,
  ) => (event: React.SyntheticEvent) => void;
}

const getDisplayText = (label: string, htmlLabel?: React.ReactNode) => {
  return htmlLabel || label;
};

export const TaggedLink = ({
  label,
  htmlLabel,
  href,
  isEcommerceNavigation,
  isOpen,
  linkStyles,
  setIsModalOpen,
  handleEcommerceClick,
}: TaggedLinkProps) => {
  if (isEcommerceNavigation) {
    return (
      <a
        href={href}
        tabIndex={isOpen ? 0 : -1}
        css={linkStyles}
        onClick={handleEcommerceClick(label, href)}
      >
        {getDisplayText(label, htmlLabel)}
      </a>
    );
  }

  if (href.startsWith('/shop/')) {
    return (
      <a
        href={href}
        tabIndex={isOpen ? 0 : -1}
        css={linkStyles}
        onClick={() => setIsModalOpen?.(false)}
      >
        {getDisplayText(label, htmlLabel)}
      </a>
    );
  }

  return (
    <Link
      to={href}
      tabIndex={isOpen ? 0 : -1}
      css={linkStyles}
      onClick={() => setIsModalOpen?.(false)}
    >
      {getDisplayText(label, htmlLabel)}
    </Link>
  );
};

export default TaggedLink;
